export default __webpack_public_path__ + "10318a2ae443016cf17fd0e1d604a0fb.svg";